import React from 'react';

// One poster shown as a plain picture. `poster` is an entry from posters.json; images live in public/posters.
export function PosterWall({ poster }) {
  return (
    <div className="fm-poster-big">
      <img src={poster.img} alt={poster.title} />
    </div>
  );
}
